<!-- IMAGE -->
<app-image
  *ngIf="config?.type === typeComponentFieldEnum.IMAGE"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-image>
<!-- IMAGE -->
<app-image-button
  *ngIf="config?.type === typeComponentFieldEnum.IMAGE_BUTTON"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-image-button>
<!-- INPUT -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-text>
<!-- INPUT-TEXT-ARE -->
<app-input-text-area
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_TEXT_AREA"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-text-area>

<!-- INPUT FILE -->
<app-input-file
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_FILE"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-file>

<!-- INPUT FILE WITH COMMENT -->
<app-input-file-with-comment
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_FILE_WITH_COMMENT"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-file-with-comment>

<!-- INPUT FILE WITH COMMENT AND DATE-->
<app-input-file-with-comment-and-date
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (onFileClick)="onFileClick.emit($event)"
  (onFileDelete)="onFileDelete.emit($event)"></app-input-file-with-comment-and-date>

<!-- INPUT_CELLPHONE_AREA_CODE -->
<app-input-cellphone-area-code
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_CELLPHONE_AREA_CODE"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-cellphone-area-code>

<app-input-number
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_NUMBER"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-number>
<app-input-currency
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_CURRENCY"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (onBlur)="onBlur.emit($event)"></app-input-currency>
<app-input-percent
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_PERCENT"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-percent>
<!-- COMBOBOX -->
<app-select
  *ngIf="config?.type === typeComponentFieldEnum.SELECT"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (onSelect)="onSelect.emit($event)"
  (onChange)="selectionChange.emit($event)"></app-select>
<app-select-advanced-search
  *ngIf="config?.type === typeComponentFieldEnum.SELECT_ADVANCED_SEARCH"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  [isMultipleSelect]="isMultipleSelect || false"
  (onSelect)="onSelect.emit($event)"
  (onChange)="selectionChange.emit($event)"></app-select-advanced-search>
<app-crud-select
  *ngIf="config?.type === typeComponentFieldEnum.SELECT_CRUD"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (onSelect)="onSelect.emit($event)"
  (onClick)="onClick.emit($event)"></app-crud-select>
<app-crud-multi-input-select
  *ngIf="config?.type === typeComponentFieldEnum.SELECT_CRUD_MULTI_SELECT"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-crud-multi-input-select>
<!-- DATAS/HORAS -->
<app-date-picker
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_DATE"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-date-picker>
<app-datetime-picker
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_DATETIME"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-datetime-picker>
<!-- CHECKS -->
<app-slide-toggle
  *ngIf="config?.type === typeComponentFieldEnum.SLIDE_TOGGLE"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group">
</app-slide-toggle>

<!-- CHECKBOX GROUP (NOVO) -->
<app-checkbox-group
  *ngIf="config?.type === typeComponentFieldEnum.CHECKBOX"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group">
</app-checkbox-group>

<!-- RADIO BUTTON GROUP (NOVO) -->
<app-radio-button-group
  *ngIf="config?.type === typeComponentFieldEnum.RADIO_BUTTON"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group">
</app-radio-button-group>

<!-- INPUT_CNPJ -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_CNPJ"
  mask="00.000.000/0000-00"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (blur)="onBlur.emit($event)"
  (change)="onChange.emit($event)"></app-input-text>

<!-- INPUT_CPF -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_CPF"
  mask="000.000.000-99"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (blur)="onBlur.emit($event)"></app-input-text>

<!-- INPUT_PHONE -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_PHONE"
  mask="(00) 00000-0009"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-text>

<!-- INPUT_PHONE -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_CELLPHONE"
  mask="(00) 00000-0009"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-text>

<!-- INPUT_ZIP_CODE -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_ZIP_CODE"
  mask="00000-0000"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (change)="onChange.emit($event)"></app-input-text>

<!-- INPUT_CEP -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_CEP"
  mask="00000-000"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (change)="onChange.emit($event)"></app-input-text>

<!-- INPUT EMAIL -->
<app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_EMAIL"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"></app-input-text>

<!-- INPUT COLOR -->
<app-input-color
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_COLOR"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (onChange)="onChange.emit($event)"></app-input-color>

  <!-- INPUT MêS/ - ANO MM/YYYY -->
  <app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_MONTH_YEAR"
  mask="00/0000"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (blur)="onBlur.emit($event)"></app-input-text>

  <!-- INPUT para CPF e CNPJ -->
  <app-input-text
  *ngIf="config?.type === typeComponentFieldEnum.INPUT_CPF_AND_CNPJ"
  [useCpfCnpjMask]="true"
  [typeCes]="typeCes"
  [config]="config"
  [group]="group"
  (blur)="onBlur.emit($event)"></app-input-text>
